$(document).ready(function () {
    $(".variant-input label" ).click(function (e) { 
        var variant_text = $(this).find('span').text();
        if(variant_text == 'Færdigopstillet')
        {
            $('#addToCartButton').addClass('hidden');
            $('.popup_button').removeClass('hidden');
        }
        if(variant_text == 'Byg selv')
        {
            $('#addToCartButton').removeClass('hidden');
            $('.popup_button').addClass('hidden');
        }
        
    });
    
});